/** @jsx jsx */
import { css } from '@emotion/react';
// no tokens for 3px exist, so using raw values
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
export const escTextStyles = css`
  border-radius: ${"var(--ds-border-radius-100, 3px)"};
  padding: 3px;
  color: ${"var(--ds-text-subtle, #44546F)"};
  background: ${"var(--ds-background-neutral, #091E420F)"};
  font-weight: ${"var(--ds-font-weight-regular, 400)"};
  margin-left: 5px;
`;